import apiClient from './apiService';
import {parseFiltersToQueryString} from "../utils/parseFiltersToQueryString";
import socket from './socketService';

class PeopleService {
  constructor() {
    if (PeopleService.instance) {
      return PeopleService.instance;
    }
    PeopleService.instance = this;
  }

  async getAll(page = 1, size = 10, filters = {}, sort =['createdAt', 'desc']) {
    try {
      const queryString = parseFiltersToQueryString(filters);
      const response = await apiClient.get(`/people?page=${page}&size=${size}&${queryString}&sort=${sort.join(',')}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching people:", error);
      throw error;
    }
  }

  async get(id) {
    try {
      const response = await apiClient.get(`/people/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching person with ID ${id}:`, error);
      throw error;
    }
  }

  async checkElectorKey(electorKey) {
    const response = await apiClient.get(`/people/check/${electorKey}`);
    return response.data;
  }

  async create(personData) {
    try {
      // Incluir socketId en los headers
      const response = await apiClient.post('/people', personData, {
        headers: {
          'X-Socket-Id': socket.id
        }
      });
      const { jobId } = response.data;

      return new Promise((resolve, reject) => {
        const eventName = `person:register:${jobId}`;

        const timeout = setTimeout(() => {
          socket.off(eventName);
          reject({ error: 'Timeout esperando respuesta del servidor' });
        }, 30000);

        socket.on(eventName, (data) => {
          clearTimeout(timeout);
          socket.off(eventName);

          if (data.status === 'completed') {
            resolve({ success: true, data: data.person });
          } else if (data.status === 'rejected') {
            reject({
              error: data.error,
              details: data
            });
          } else {
            // status === 'failed'
            let errorMsg = 'Error al procesar el registro';
            if (data.details) {
              // Errores de validación del DTO
              const validationErrors = Object.values(data.details).flat();
              errorMsg = validationErrors.length > 0
                ? validationErrors.join(', ')
                : data.error;
            } else {
              errorMsg = data.error;
            }
            reject({ error: errorMsg, details: data.details });
          }
        });
      });
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw Error("Error server connection.");
    }
  }

  async update(id, personData) {
    try {
      const response = await apiClient.put(`/people/${id}`, personData);
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw Error("Error server connection.");
    }
  }

  async delete(id) {
    try {
      await apiClient.delete(`/people/${id}`);
      return { success: true, message: "Person deleted successfully" };
    } catch (error) {
      console.error(`Error deleting person with ID ${id}:`, error);
      throw error;
    }
  }

  static getInstance() {
    if (!PeopleService.instance) {
      PeopleService.instance = new PeopleService();
    }
    return PeopleService.instance;
  }
}

export default PeopleService.getInstance();
